import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';

export const GalleryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    justify-content: space-between;
  }
`;

export const ImgWrapper = styled.div`
  justify-content: center;
  display: flex;
  position: relative;
  width: calc(100vw);
  margin: 0 calc(-${themeGet('media.grid-gutter.2')} / 2) 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    margin: 0 calc(-${themeGet('media.grid-gutter.3')} / 2) 20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 49%;
    max-width: 625px;
    margin: 0 auto 2%;
    padding-bottom: 0;

    &:nth-child(odd) {
      margin-right: 1%;
    }

    &:nth-child(even) {
      margin-left: 1%;
    }
  }
`;

export const GalleryImage = styled(Image)`
  height: 275px;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: auto;
  }
`;
